import React, { useState, useRef, useEffect } from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

// Compontents //
import TitleSection from "../../molecules/title-section";
import SearchFilterEncTal from "../../molecules/search-filter-encontrar-talento/searchFilterEncTal";
import FilterTagListEncTal from "../../molecules/filter-tag-list-encontrar-talento/filterTagListEncTal";
import ListFiltersEncTal from "../../organisms/list-filters-encontrar-talento/listFiltersEncTal";
import TalentsAvailable from "../../atoms/talents-available/talentsAvailable";
import ListOpenTalents from "../../organisms/list-open-talents/listOpenTalents";
import Pagination from "../../molecules/pagination/Pagination";
import TalentsSelected from "../../atoms/talents-selected/talentsSelected";
import Button from "../../atoms/button/button";
import { isMobile } from "../../../utils/helpers";
import ModalConocerTalento from "../../molecules/modal-conocer-talento/modalConocerTalento";
import { wordFixerForGTM } from "../../../shared/utils/stringUtilities"

import { getCatalogData, getCandidatesByFilter } from "../../../services/encontrarTalento.services";

// Styles //
import "./encontrarTalento.scss";

// Context //
import TalentsContext from "../../../contexts/talentsContext";
import { TalentsContextInterface } from "interfaces/ReferenciaEncontrarTalento";

const PageSize = 10;    

const EncontrarTalento = (props: ReferenciaContenido) => {
    const [showFilters, setShowFilters] = useState<boolean>(false);
    const posRef = useRef<HTMLDivElement>(null);
    const [talentsSelectedIds, setTalentsSelectedIds] = useState<any>([])
    const [isVisible, setIsVisible] = useState(false);
    const [talentsHelper, setTalentsHelper] = useState<any[]>([]);
    
    let filterParam: string = "";
    
    const initialValuesFilters = {
        region: {
            items: [],
        },
        city: {
            items: [],
        },
        educationLevel: {
            values: [],
            items: [],
        },
        profession: {
            values: [],
            items: [],
        },
        area: {
            values: [],
            items: [],
        },
        populationGroup: {
            values: [],
            items: [],
        },
        language: {
            items: [],
        },
        languageLevel: {
            items: [],
        },
        keyWord: {
            items: [],
        },
    };

    const [loading, setLoading] = useState<boolean>(true);
    const [keyWord, setKeyWord] = useState("");
    const [talents, setTalents] = useState<any[]>([]);
    const [filterCatalogData, setFilterCatalogData] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [currentTotal, setCurrentTotal] = useState<number>(0);
    const [queryParameters, setQueryParameters] = useState<string>(filterParam);
    const { localStorage } = useBrowserMode();
    const [selectedFilters, setSelectedFilters] = useState<any>(initialValuesFilters);
    const onSubmitSearchHandler = () => {
        setLoading(true);
        createQueryParameters();
    };
    const createQueryParameters = (page?) => {
        let string = "";
        if (page) {
            string += `&page=${page}`;
        }
        if (selectedFilters.region?.items.length !== 0) {
            string += `&subRegion=${selectedFilters.region?.items[0].value}`;
        }
        if (selectedFilters.city?.items.length !== 0) {
            string += `&municipio=${selectedFilters.city?.items[0].value}`;
        }
        if (selectedFilters.educationLevel?.items.length !== 0) {
            string += `&nivelAcademico=${selectedFilters.educationLevel?.values.join(",")}`;
        }
        if (selectedFilters.profession?.values.length !== 0) {
            string += `&profesion=${selectedFilters.profession?.values.join(",")}`;
        }
        if (selectedFilters.area?.values.length !== 0) {
            string += `&areaExperiencia=${selectedFilters.area?.values.join(",")}`;
        }
        if (selectedFilters.populationGroup?.values.length !== 0) {
            string += `&grupoPoblacional=${selectedFilters.populationGroup?.values.join(",")}`;
        }
        if (selectedFilters.language?.items.length !== 0) {
            string += `&idioma=${selectedFilters.language?.items[0].value}`;
            if (selectedFilters.languageLevel?.items.length !== 0) {
                string += `&nivelIdioma=${selectedFilters.languageLevel?.items[0].value}`;
            }
        }
        setQueryParameters(filterParam + string);
    };

    const getData = async () => {
        setLoading(true);
        await getCandidatesByFilter(queryParameters)
        .then((response) => {
            const { data } = response.data;
            setTalents(data.candidatos);
            setCurrentTotal(data.total);
            setLoading(false);
        })
        .catch((err) => {
            console.log("Error al obtener Candidatos: " + err);
        });
    };

    useEffect(() => {
        const getCatData = async () => {
            await getCatalogData()
            .then((response) => {
                if (localStorage.getItem("talentosCatalogData")) {
                    setFilterCatalogData(JSON.parse(localStorage.getItem("talentosCatalogData")!));
                }
                else {
                    if (response.data.data) {
                        localStorage.setItem("talentosCatalogData", JSON.stringify(response.data.data))
                        setFilterCatalogData(response.data.data);
                    }
                }
            })
            .catch((err) => {
                console.log("Error al obtener Data de catalogos: " + err);
            });
        }
        getCatData();
    }, []);

    useEffect(() => {
        getData();
    }, [queryParameters]);

    useEffect(() => {
        createQueryParameters();
    }, [
        selectedFilters.page,
        selectedFilters.region,
        selectedFilters.city,
        selectedFilters.educationLevel,
        selectedFilters.profession,
        selectedFilters.area,
        selectedFilters.populationGroup,
        selectedFilters.language,
        selectedFilters.languageLevel
    ]);

    useEffect(() => {
        if (currentPage != 0) createQueryParameters(currentPage - 1);
    }, [currentPage]);

    //Bloque creado para desaparecer y aparecer el banner en el viewport
    useEffect(() => {
        const handleScroll = () => {
          const targetElement = document.getElementById('talentSelected');
          const boundingBox = targetElement?.getBoundingClientRect();
    
          //Valida si el target element esta en el viewport
          if (boundingBox!! && boundingBox.top >= 0 && 
            boundingBox.bottom <= window.innerHeight) {
            setIsVisible(false);
          } else {
            setIsVisible(true);
          }
        };
    
        // Scroll listener
        window.addEventListener('scroll', handleScroll);
    
        // Llama handleScroll una vez para verificar el estado inicial
        handleScroll();
    
        // Limpia el scroll listener cuando el componente se desmonte
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    //Bloque creado para desaparecer y aparecer el banner en el viewport

    // Bloque creado para el modal //
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

    const closeModal = () => {
        document.body.style.overflow = "scroll";
        setIsOpenModal((setShow) => !setShow);
    };
    // Bloque creado para el modal //

    //Bloque creado para DataLayer GTM//
    const createDataLayerTags = () => {
        talentsSelectedIds.forEach(id => {
            talents.forEach(talent => {
                if (talent.numeroDocumento === id && window.dataLayer) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'pushToDataLayer',
                        'conocertalento' : `empleo_empresas_encontrar_talento_solicitar_${wordFixerForGTM(talent.nivelEducativo?.map(i => i.tituloProfesional).toString())}`
                    });
                }
            })
        })
    }
    //Bloque creado para DataLayer GTM//

    const GlobalStore: TalentsContextInterface = {
        loading: loading,
        keyWord: keyWord,
        queryParameters: queryParameters,
        talents: talents,
        filterCatalogData: filterCatalogData,
        selectedFilters: selectedFilters,
        initialSelectedFilters: initialValuesFilters,
        currentPage: currentPage,
        currentTotal: currentTotal,
        setCurrentPage: setCurrentPage,
        setKeyWord: setKeyWord,
        setQueryParameters: setQueryParameters,
        setSelectedFilters: setSelectedFilters,
        onSubmitSearchHandler: onSubmitSearchHandler
    };

    //Bloque creado para obtener los datos de los talentos seleccionados//
    const getTalentsValues = (talentsSelectedIds, sentToLocalStorage) => {
        //Se obtiene la informacion del talento
        const selectedTalents = talents.filter(talent => talentsSelectedIds.includes(talent.numeroDocumento));
        setTalentsHelper(prevArray => {
            //Se filtran los duplicados
            const filteredTalents = selectedTalents.filter(talent =>
                !prevArray.some(prevTalent => prevTalent.numeroDocumento === talent.numeroDocumento)
            );
            //Se añaden los filtrados con el prevArray
            const newTalentsHelper = [...prevArray, ...filteredTalents];
            //Si se da click en el boton conocer talentos, se guardan los datos en el localStorage
            if (sentToLocalStorage) {
                //Se envia la constante porque en ocasiones al llamar el state no se habia actualizado
                localStorage.setItem("talentsSelected", JSON.stringify(newTalentsHelper));
            }
            return newTalentsHelper;
        });
    }
    //Bloque creado para obtener los datos de los talentos seleccionados//
    
    return (
        <TalentsContext.Provider value={GlobalStore}>
            <div
                className="container-positions CabeceraSalaPrensa2"
                id="CabeceraSalaPrensa25"
                data-id="5"
                ref={posRef}
            >
                <div className="container-encontrar-talento">
                    {(talentsSelectedIds.length > 0) && (isVisible || isMobile()) && (
                        <div className="container-encontrar-talento__banner">
                            <h2>
                                Tienes {talentsSelectedIds.length} {talentsSelectedIds.length > 1 ? 'talentos seleccionados' : 'talento seleccionado'}

                                <Button
                                    onClickAction={() => {
                                        setIsOpenModal(true);
                                        getTalentsValues(talentsSelectedIds, true);  
                                        createDataLayerTags();
                                    }}
                                    type="button"
                                    text={
                                        `${talentsSelectedIds.length > 1
                                        ? 'CONOCER TALENTOS'
                                        : 'CONOCER TALENTO'}`
                                    }
                                    classname={`a-button__magenta`}
                                    isDisabled={false}
                                />
                            </h2>
                        </div>
                    )}
                    <div className="container-encontrar-talento__inner">
                        {props.tituloGeneral && (
                            <div  className="container-encontrar-talento__title">
                                <TitleSection
                                    title={`${props.tituloGeneral}`}
                                    type="h1"
                                />
                            </div>
                        )}
                        <div className="container-encontrar-talento__box">
                            <div className="container-encontrar-talento__filters">
                                <div className="container-encontrar-talento__filters__interactions">
                                    <SearchFilterEncTal/>
                                    <FilterTagListEncTal handleFilters={() => setShowFilters(!showFilters)}/>
                                    <div className={`container-encontrar-talento__filters__interactions__content ${ showFilters ? "show" : "hide" }`}>
                                        {/* TODO - filtros */}
                                        <ListFiltersEncTal handleFilters={() => setShowFilters(!showFilters)}/>
                                    </div>                          
                                </div>
                            </div>
                            <div className="container-encontrar-talento__list">
                                <TalentsAvailable/>
                                {talentsSelectedIds.length > 0 && (
                                    <TalentsSelected
                                        talentsSelectedIds={talentsSelectedIds}
                                        getTalentsValues={getTalentsValues}
                                        createDataLayerTags={createDataLayerTags}
                                    />
                                )}
                                {/* TODO - filtros */}
                                <ListOpenTalents 
                                    talentsSelectedIds={talentsSelectedIds}
                                    setTalentsSelectedIds={setTalentsSelectedIds}
                                    talentsHelper={talentsHelper}
                                    setTalentsHelper={setTalentsHelper}
                                />
                                {currentPage &&
                                    <div className="container-encontrar-talento__list__pagination">
                                        <Pagination
                                            className="pagination-bar"
                                            currentPage={currentPage}
                                            totalCount={currentTotal}
                                            pageSize={PageSize}
                                            onPageChange={(page) => {
                                                setCurrentPage(page);
                                                getTalentsValues(talentsSelectedIds, false);
                                                window.scrollTo({
                                                    top: 620,
                                                    behavior: "smooth",
                                                });
                                            }}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {isOpenModal && (
                    <ModalConocerTalento
                        showModal={isOpenModal} 
                        onClose={closeModal}
                        talentsSelectedIds={talentsSelectedIds.length}
                    />
                )}
            </div>
        </TalentsContext.Provider>
    );
};

export default EncontrarTalento;
